/* This file is autogenerated, see readme.md for instructions */
import PaintSvgIcon from '@bloomreach/banana-theme/icons/paint.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const PaintIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <PaintSvgIcon />
    </Icon>
  );
});

PaintIcon.displayName = 'PaintIcon';

export default PaintIcon;
